module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#youtube",
      toString: function () {
        return this.url;
      }
    }